import { HttpParams } from '@angular/common/http';
import { HttpService } from '../../shared/services/http.service';
import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';
import { environment as env } from 'src/environments/environment';

@Injectable({
  providedIn: 'root',
})
export class AttivitaService {
  public $addressSubject = new BehaviorSubject<any>(null);
  public $provinceSubject = new BehaviorSubject<any>(null);
  public $presentedProductSubjects = new BehaviorSubject<any>(null);
  private options;

  private formValidationSubject = new BehaviorSubject<{ isValid: boolean; errors?: string[] }>({ isValid: false });
  public $formValidation = this.formValidationSubject.asObservable();

  constructor(private readonly http: HttpService) {
    this.options = {};
  }

  getActivitiesList(page?: number, size?: number, filters?: any): Observable<any> {
    const httpParams = new HttpParams({ fromObject: filters ?? {} })
      .set('page', (page ?? 1).toString())
      .set('pageResults', (size ?? 1000).toString());

    return this.http.get<any>(env.baseUrl + 'ActivityUser', { params: httpParams, ...this.options });
  }

  getActivityForm(id: number): Observable<any> {
    return this.http.get<any>(env.baseUrl + 'Activity/' + id, { ...this.options });
  }

  getActivitiesByCategory(idCategory: number): Observable<any> {
    return this.http.get<any>(env.baseUrl + 'Activity/GetByCategory/' + idCategory, { ...this.options });
  }

  getActivitiesInputs(appType: boolean): Observable<any> {
    return this.http.get<any>(env.baseUrl + 'Activity/?page=1&pageResults=100&app=' + appType, { ...this.options, noLoader: true });
  }

  createUserActivity(data: any): Observable<any> {
    return this.http.post<any>(env.baseUrl + 'ActivityUser', data);
  }

  editUserActivity(data: any): Observable<any> {
    return this.http.put<any>(env.baseUrl + 'ActivityUser', data);
  }

  deleteUserActivity(id: number): Observable<any> {
    return this.http.delete<any>(env.baseUrl + 'ActivityUser/' + id);
  }

  getTimeSlots(): Observable<any> {
    return this.http.get<any>(env.baseUrl + 'Activity/GetTimeSlots');
  }

  storeActivityForm(data: any): Observable<any> {
    return this.http.post<any>(env.baseUrl + 'Activity', data, this.options);
  }

  getActivitiesRoles(): Observable<any> {
    return this.http.get<any>(env.baseUrl + `Activity/GetRoles`);
  }

  getActivitiesFieldsForm(): Observable<any> {
    return this.http.get<any>(env.baseUrl + `Activity/GetFieldForm`);
  }

  editActivityForm(data: any): Observable<any> {
    return this.http.put<any>(env.baseUrl + 'Activity', data, this.options);
  }

  editActivityByCategory(data: any): Observable<any> {
    return this.http.put<any>(env.baseUrl + 'Activity/EditByCategory', data, this.options);
  }

  deleteActivity(id: number): Observable<any> {
    return this.http.delete<any>(env.baseUrl + 'Activity?id=' + id);
  }

  getActivityEditRequests(page?: number, size?: number): Observable<any> {
    const url = env.baseUrl + 'ActivityUser/Pending?page=' + page + '&pageResults=' + size;
    return this.http.get<any>(url, this.options);
  }

  approveActivityEditRequest(idDoctor: number, idActivity: number, token?: string): Observable<any> {
    let url = env.baseUrl + 'ActivityUser/Pending?idDoctor=' + idDoctor + '&idPendingUserActivity=' + idActivity;
    if (token) {
      url += '&token=' + token;
    }
    return this.http.put<any>(url, null, this.options);
  }

  refuseActivityEditRequest(idDoctor: number, idActivity: number, token?: string): Observable<any> {
    let url = env.baseUrl + 'ActivityUser/Pending?idDoctor=' + idDoctor + '&idPendingUserActivity=' + idActivity;
    if (token) {
      url += '&token=' + token;
    }
    return this.http.delete<any>(url, this.options);
  }

  downloadFile(url: string): Observable<Blob> {
    return this.http.get(env.baseUrl + url, { ...this.options, responseType: 'blob' });
  }

  downloadVisitReport(filters: any): Observable<Blob> {
    const params = new HttpParams({ fromObject: filters });
    return this.http.get(`${env.baseUrl}VisitReport/export`, {
      params,
      responseType: 'blob',
    });
  }

  updateFormValidation(isValid: boolean, errors?: string[]) {
    this.formValidationSubject.next({ isValid, errors });
  }

  resetFormValidation() {
    this.formValidationSubject.next({ isValid: false });
  }

  getUsers(page?: number, size?: number, filters?: any): Observable<any> {
    const params = new HttpParams({ fromObject: filters });
    return this.http.get<any>(env.baseUrl + 'User' + '?page=' + page + '&pageResults=' + size + '&' + params, this.options);
  }

  getActivitiesGrouped(roles?: number): Observable<any> {
    let params = new HttpParams().set('grouped', 'true');
    if (roles) {
      params = params.set('roles', roles);
    }
    return this.http.get<any>(env.baseUrl + 'Activity/', { ...this.options, params });
  }

  getStructuresSelectV1(params?: any): Observable<any> {
    let httpParams = new HttpParams();
    if (params) {
      Object.keys(params).forEach((key) => {
        if (params[key]) httpParams = httpParams.set(key, params[key]);
      });
    }

    return this.http.get<any>(`${env.baseUrl}Facility`, {
      ...this.options,
      params: httpParams,
    });
  }
}
